import Vue from 'vue';
import Router from 'vue-router';
import BRoot from '../views/BRoot.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: BRoot,
      children: [
        {
          path: '/home',
          component: () => import('../views/BHome.vue'),
        },
        {
          path: '/doh-dot-policy.html',
          component: () => import('../views/BDohDotPolicy.vue'),
        },
      ]
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

export default router;
